import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { GetCampaignPublicByIdGQL, SearchActivityEvents } from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-mass-add-entities-to-campaign-event',
  templateUrl: './mass-add-entities-to-campaign-event.component.html'
})

export class ASMassAddEntitiesCampaignEventComponent extends
  WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  campaignName = 'another campaign';

  get payload() {
    return this.item?.payload;
  }

  /**
   *
   */
  constructor(
    private _getCampaignPublicGQL: GetCampaignPublicByIdGQL,
    private _cd: ChangeDetectorRef
    ) {
    super();
  }

  ngOnInit() {
    const campaignId =  this.payload.operationData.campaignId;
    this._getCampaignPublicGQL.fetch({campaignId}).subscribe(({data}) => {
      this.campaignName = data.getCampaignPublic.name;
      this._cd.markForCheck();
    });
  }
}


